import { all } from "redux-saga/effects"
import loadCalendar from "./loadCalendar"
import initCalendar from "./initCalendar"

export default function* calendarSaga() {
  while (true) {
    yield all({
      loadCalendar: loadCalendar(),
      initCalendar: initCalendar(),
    })
  }
}
